const newAlertsKeyVals = [
  {
    id: 'new_tickets',
    title: 'درخواست‌های جدید',
  },
  {
    id: 'open_tickets_wait_for_admin',
    title: 'درخواست‌های منتظر پاسخ ادمین',
  },
  {
    id: 'notif',
    title: 'نامه جدید: ',
    // title: 'پیغام\u200cها: ',
  },
];

export default newAlertsKeyVals;
